import register from '@/components/features/cms/blocks/DamVideo/register';
import { DamVideoWithOverrides } from './DamVideoWithOverrides';

register(DamVideoWithOverrides);
